import React from 'react'

export const SvgLinkArrow = () =>{
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="5.021" height="8.904" viewBox="0 0 5.021 8.904">
      <path id="icon-up" d="M5621.7,231.783l3.021,3.261-3.021,3.643" transform="translate(-5620.697 -230.783)" fill="none" stroke="#de4547" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
    </svg>
  )
}